import styled from 'styled-components';

import { colors } from 'theme/theme';

export const ListingPageSectionContainer = styled.div`
  border-top: solid 1px ${colors.selectionGrey};
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: 16px;
  margin-bottom: 32px;
`;
